"use strict";

import angular from "angular";

import template from "./help-item-glossary.component.html";
import "./themes/help-item-glossary.component.scss";
import "./themes/help-item-glossary-dark.component.scss";

class HelpItemGlossaryComponent {
    constructor() {}

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

HelpItemGlossaryComponent.$inject = [];

const name = "helpItemGlossaryComponent";
const def = {
    bindings: {
        content: "<"
    },
    controller: HelpItemGlossaryComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
